import {RegionEntity} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {
  AllocatableLoadSettingsDataTableCard
} from "../../card/AllocatableLoadSettingsDataTableCard/AllocatableLoadSettingsDataTableCard";
import {HasAccess} from "@ots-frontend/ots-ui";

export type RegionDetailsProps = {
  region: RegionEntity
}

export const RegionDetails = (props: RegionDetailsProps) => {
  const {region} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={6}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{t("common.entity.region.profile.info.section.details.label", "Details")}</Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.name.label", "Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.name}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.geographicname.label", "Geographic Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.geographicName}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.timezone.label", "Time Zone")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.timeZone}
              </Text>
            </Grid.Col>
            <Grid.Col span={12}>
              <Divider/>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.volumeuom.label", "Volume Units")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.volumeUnitOfMeasure}
              </Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.areauom.label", "Area Units")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.areaUnitOfMeasure}
              </Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.weight.label", "Weight Units")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.weightUnitOfMeasure}
              </Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.linearuom.label", "Linear Units")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.linearUnitOfMeasure}
              </Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.pressureuom.label", "Pressure Units")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.pressureUnitOfMeasure}
              </Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.temperatureuom.label", "Temperature Units")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.temperatureUnitOfMeasure}
              </Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.region.profile.info.field.odometeruom.label", "Odometer Units")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {region.odometerUnitOfMeasure}
              </Text>
            </Grid.Col>
          </Grid>
        </Card>
      </Grid.Col>
      <HasAccess permissions={["region_edit"]}>
        <Grid.Col span={12}>
          <AllocatableLoadSettingsDataTableCard entity={region}/>
        </Grid.Col>
      </HasAccess>
    </Grid>
  );
};

